module.exports = __webpack_public_path__ + "img/dwgk.7f204ecc.png";